import React, { Component } from 'react';
import { Button, Card, Layout, message, Transfer } from 'antd';
import { BackBtn, goBack } from '@comm/BackBtn';
import { queryCompanyCustomList, queryCustomList, querySaveCompanyCustom } from '@api/crm/custom';

class Add extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      targetKeys: [],
      selectedKeys: [],
    };
  }

  componentWillMount() {
    const { uuid } = this.props.routeParams;
    this.loadData(uuid);
    this.getCustomList();
  }

  loadData = () => {
    const context = this;
    const params = {};
    params.orgUuid = this.props.params.uuid;
    queryCompanyCustomList(params).then(res => {
      if (res.statusCode === 200) {
        const datas = [];
        for (let i = 0; i < res.data.length; i++) {
          datas.push(res.data[i].uuid);
        }
        context.setState({ targetKeys: datas });
      } else {
        message.error(res.message);
      }
    });
  };

  getCustomList = (pageNo, pageSize) => {
    const params = {};
    params.pageNo = pageNo || 1;
    params.pageSize = pageSize || 15;
    queryCustomList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data.result,
        });
      }
    });
  };

  save = () => {
    const { uuid } = this.props.params;
    const params = {};
    params.orgUuid = uuid;
    params.customUuids = this.state.targetKeys;
    querySaveCompanyCustom(params).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        goBack();
      } else {
        message.error(res.message);
      }
    });
  };

  handleChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({
      selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys],
    });
  };

  render() {
    const { state } = this;
    return (
      <Layout>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <Button icon="save" style={{ marginRight: 10 }} onClick={this.save}>
            保存
          </Button>
        </div>
        <Card>
          <Transfer
            rowKey={record => record.uuid}
            dataSource={state.data}
            listStyle={{ width: 300, height: 400 }}
            titles={['所有客户', '关联客户']}
            targetKeys={state.targetKeys}
            selectedKeys={state.selectedKeys}
            onChange={this.handleChange}
            onSelectChange={this.handleSelectChange}
            render={item => item.name}
            notFoundContent="暂无客户"
          />
        </Card>
      </Layout>
    );
  }
}

export default Add;



// WEBPACK FOOTER //
// ./src/components/custom/company/PageConfig.js